import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActionSheetController, AlertController, LoadingController } from '@ionic/angular';
import { BaseComponent } from 'src/app/base/base.component';
import { PagesToNavigateService } from 'src/app/base/pages.service';
import { SearchState } from 'src/app/data/states/search.state';
import { TypeSearchingBy } from 'src/app/domain/model/TypeSearchingBy';
import { SearchEnrollmentUseCase } from 'src/app/domain/usecases/search/search-enrollment.usecase';
import { AuthService } from 'src/app/guards/auth.service';
import { AlertService } from 'src/app/services/alert.service';
import { StorageService } from 'src/app/services/storage.service';
import { StringUtils } from 'src/app/util/string.utils';


@Component({
  selector: 'app-search-enrollment',
  templateUrl: './search-enrollment.component.html',
  styleUrls: ['./search-enrollment.component.scss'],
})
export class SearchEnrollmentComponent extends BaseComponent implements OnInit {
  private TypeSearchingBy = TypeSearchingBy
  private searchType: TypeSearchingBy = TypeSearchingBy.none
  private searchForm: FormGroup;

  constructor(
    private actionSheetCtrl: ActionSheetController,
    protected router: Router,
    protected storageService: StorageService,
    private formBuilder: FormBuilder,
    private searchEnrollmentUseCase: SearchEnrollmentUseCase,
    protected loadingCtrl: LoadingController,
    private alerterService: AlertService,
    private searchState: SearchState,
    protected alertController: AlertController,
    protected authService: AuthService,
    protected pagesToNavigateService: PagesToNavigateService,
  ) {
    super(loadingCtrl, router, storageService, alertController, authService, pagesToNavigateService);   
  }

  ngOnInit() {
    this.presentActionSheet()
    this.initSearchFormGroup()
    this.handleFormErrors()
  }

  private async presentActionSheet() {

    const actionSheet = await this.actionSheetCtrl.create({
      mode: 'ios',
      backdropDismiss: false,
      header: 'Búsqueda por',
      buttons: [
        {
          text: 'Email',
          handler: () => {
            this.searchType = TypeSearchingBy.email
            this.searchForm = this.formBuilder.group({
              rfc: [''],
              email: ['', [Validators.required, Validators.email]],
            })
          }
        },
        {
          text: 'RFC',
          handler: () => {
            this.searchType = TypeSearchingBy.identification
            this.searchForm = this.formBuilder.group({
              rfc: ['', [Validators.required, Validators.pattern(StringUtils.rfcRegexString())]],
              email: [''],
            });
            this.searchForm.get('rfc').valueChanges.subscribe((event) => {
              this.searchForm.get('rfc').setValue(event.toUpperCase(), { emitEvent: false });
            });
          },
        },
      ],
    });

    await actionSheet.present();
  }

  private isTypeSelected = (typeSearch: TypeSearchingBy) => this.searchType === typeSearch

  private handleFormErrors() {
    this.searchForm.controls['email'].setErrors({ 'emailError': true });
    this.searchForm.controls['rfc'].setErrors({ 'rfcError': true });
  }

  private initSearchFormGroup() {
    this.searchForm = this.formBuilder.group({
      rfc: [''],
      email: [''],
    });
  }

  get rfc() {
    return this.searchForm.get('rfc');
  }

  get email() {
    return this.searchForm.get('email');
  }

  private selectionTypeSearch() {
    this.presentActionSheet()
  }

  private searchDataEnrollment() {
    this.showLoading()
    this.searchEnrollmentUseCase.execute(
      {
        dataToSearch: this.searchType === TypeSearchingBy.email ? this.email.value : this.rfc.value,
        typeSearchingBy: this.searchType,
        metadata: this.buildMetadata()
      }
    ).subscribe((searchResponse) => {
      this.closeLoader()

      this.handleResponseDataNoMessage(
        searchResponse,
        () => {
          searchResponse.data.typeSearchingBy = this.searchType;
          searchResponse.data.dataSearched = this.searchType === TypeSearchingBy.email ? this.email.value : this.rfc.value;
          this.searchState.value$ = searchResponse.data;
          console.log("Search enrollmente success, showing data...")
          this.navigateToResultView()
        }
      )
    }, error => {
      this.closeLoader()
      console.log("Search enrollmente error: " + error.message)
      this.alerterService.presentAlert('', error.message);
    })
  }

  private navigateToResultView() {
    this.navigateTo('enrollment/search-result')
  }
}

